import { OptionItem } from 'app/components/display-selected-options/display-selected-options';
import { DistributionPanelTexts } from './components/distribution-panel-texts';
import { ComplexValue } from 'ui';

export const getDistributionSelectedOption = (
  translation: DistributionPanelTexts,
  exposureApplication: ComplexValue<number>,
  exposureFactor?: number, 
  exposurePercent?: number
): OptionItem => {
  const values: string[] = [];
  if (!!exposureFactor) {
    values.push(`${translation.distribution_for_every}: ${exposureFactor}`);
  }
  if (!!exposurePercent) {
    values.push(`${translation.distribution_percent_inrease}: ${exposurePercent}`);
  }

  return {
    value: 'distribution',
    label: translation.distribution_title,
    selections: {
      titles: [],
      values: [(`${exposureApplication.description}` + (!!values.length ? ` (${values.join(', ')})`: ''))],
      excludedValues: []
    }
  };
};
